/* eslint-disable */

import React, { useContext, useMemo, useRef, useState } from "react";
import { Box } from "@mui/material";
import { StepProps } from "../../source-configurator.types";
import SidebarStepFooter from "../../sidebar-step-footer";
import { wizardcontext } from "../../../source-configurator-tool";
import {
    ValidationList,
    ValidationListElement,
    SetAPIStatusProperty
} from "src/modules/wizards/common/validation-list/validation-list";
import { ValidationListRef } from "src/modules/flow-designer/vts/select-tables-modal/components/validation-list/validation-list";
import { generateValidationList } from "src/modules/flow-designer/vts/components/validation-steps/validation-steps";

const VALIDATION_TIMEOUT = 2_000;

const ValidateConnectionStep = ({ onNext, onBack, onCancel }: StepProps) => {
    const { sourceType, mode, connectionParams, setState } = useContext(wizardcontext);
    const [apiStatus, setAPIStatus] = useState<SetAPIStatusProperty>({});
    const validationRef = useRef<ValidationListRef>(null);

    const validationItems: ValidationListElement[] = useMemo(
        () =>
            generateValidationList({
                type: sourceType ?? "",
                isCDC: mode === "Change Data Capture",
                model: connectionParams,
                isAutomatedAppFlow: mode === "Automated",
                isPureReactView: true,
                setState
            }),
        []
    );

    const handleRetry = () => {
        if (apiStatus.canRetry) {
            setAPIStatus({});

            validationRef?.current?.retryAPI();
        } else {
            setTimeout(async () => {
                onNext();
            }, VALIDATION_TIMEOUT);
        }
        setAPIStatus(prevState => ({
            ...prevState,
            isAPISuccessful: false,
            isAPICompleted: false
        }));
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ mb: 2, width: "100%" }}>
                <ValidationList
                    ref={validationRef}
                    validationList={validationItems}
                    async={true}
                    onSuccess={onNext}
                    setAPIStatus={setAPIStatus}
                    controlAppWizardFooter={false}
                />
            </Box>
            <SidebarStepFooter
                onCancel={onCancel}
                onBack={onBack}
                onNext={handleRetry}
                showNext={!!apiStatus.canRetry}
                nextDisabled={!apiStatus.isAPICompleted}
                backDisabled={!apiStatus.isAPICompleted}
                nextLabel={apiStatus.canRetry ? "Retry" : "Next"}
            />
        </Box>
    );
};

export default ValidateConnectionStep;
